import { lazy, FC, Suspense, useEffect, useContext, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import Summary from "../layout/components/Summary/Summary";
import Tabledata from "../layout/components/Table/Table";
import MasterLayout from "../master-layout";
import AdminUsers from "../modules/home/admin/admin-users";
import Dashboard from "../modules/home/dashboard/dashboard";
import FieldSettings from "../modules/home/admin/field-settings";
import FYSettings from "../modules/home/admin/settings";
import CollectionSequences from "../modules/home/admin/collection-sequences";
import { AppContext } from "../utils/state";
import { useAuth } from "../modules/auth";
import { get, getProfile } from "../utils/api";
import Profile from "../modules/profile";
import CRUDModule from "../dca-modules/crud";
import CollectionSettings from "../modules/home/admin/collection-settings";
import SideMenuSettings from "../modules/home/admin/sidemenu-settings";
import TokenGenerator from "../modules/home/admin/api-token";
import APIs from "../modules/home/admin/apis";
import EditModule from "../dca-modules/crud/Edit";

const PrivateRoutes = () => {
  const location = useLocation();
  const { state, dispatch } = useContext(AppContext);
  const { currentUser } = useAuth();
  const [crudModules, setCrudModules] = useState([]);
  const [modulesFetched, setModulesFetched] = useState(false); // flag to control module fetching

  useEffect(() => {
    if (!state.user._id && !state.isAuthenticated) {
      fetchProfile();
    }

    // Fetch modules only once or when location changes
    if (!modulesFetched) {
      fetchModules();
      setModulesFetched(true);
    }
  }, [location]);

  const fetchModules = async () => {
    try {
      const data = await get("field_settings", { limit: 20 });
      setCrudModules(data.data.data || []);
    } catch (error) {
      console.error("Error fetching CRUD modules:", error);
    }
  };

  const fetchProfile = async () => {
    try {
      const data = await getProfile();
      dispatch({
        type: "setUser",
        user: data.user,
      });
      dispatch({
        type: "setAuth",
        data: true,
      });
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin/field-settings/*" element={<FieldSettings />} />
        <Route path="/admin/admin-users/*" element={<AdminUsers />} />
        <Route
          path="/admin/collection-settings"
          element={<CollectionSettings />}
        />
        <Route path="/admin/side-menu" element={<SideMenuSettings />} />
        <Route path="/admin/api-token" element={<TokenGenerator />} />
        <Route path="/profile" element={<Profile />} />
        <Route
          path="/profile/edit"
          element={<EditModule module={"admin_users"} id={state.user.admin_user_id} primary_key={"admin_user_id"} />}
        />
        <Route path="/admin/apis" element={<APIs />} />

        {/* Dynamically generated CRUD modules */}
        {crudModules.map((module:any) => (
          <Route
            key={module.collection_name}
            path={`/${module.collection_name}/*`}
            element={
              <CRUDModule
                module={module.collection_name}
                primary_key={module.primary_key}
              />
            }
          />
        ))}

        <Route path="/summary" element={<Summary />} />
        <Route index element={<Navigate to="/dashboard" />} />
      </Route>
    </Routes>
  );
};

export { PrivateRoutes };
